import Input from "@components/ui/input";
import { IconSearch } from "@tabler/icons-react";
import * as React from "react";

interface Props
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "value" | "onChange" | "size"
  > {
  value: string;
  onChange: (value: string) => void;
}

export const PickerSearch = React.forwardRef<HTMLInputElement, Props>(
  ({ value, onChange, ...rest }, ref) => (
    <div className="tw-relative">
      <IconSearch
        stroke={1.5}
        className="tw-pointer-events-none tw-absolute tw-left-3 tw-top-1/2 tw-z-10 tw-size-4 -tw-translate-y-1/2 tw-text-blue-500"
      />
      <Input
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search"
        className="tw-pl-9"
        {...rest}
      />
    </div>
  ),
);
PickerSearch.displayName = "PickerSearch";
